import React, {useEffect, useState} from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  Alert, Modal,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import * as fb from '../../firebase';
import {
  addAdminLog,
} from "components/Helper/index";
import { Link } from "react-router-dom";
import StringArrayInput from "../../components/StringArrayInput/StringArrayInput";

const AddClassPopup = (props) => {
  const [newClass, setNewClass] = useState({ref:'',title:'',order:0})
  const [prices, setPrices] = useState({uk:0, hu:0});
  const [errors, setErrors] = useState({})

  useEffect(() => {

  }, []);

  const addClass = () => {
    if(handleValidation()){
      props.onCreate(newClass,prices)
    }
  }

  const changeClass = (e,field) => {
    let value = e.target.value
    setNewClass(prev => ({...prev, [field]: value}))
  }

  const changePrice = (e,field) => {
    let value = parseInt(e.target.value*100)
    setPrices(prev => ({...prev, [field]: value}))
  }

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if(!newClass.ref){
      formIsValid = false;
      errors["ref"] = "Ref is required";
    }

    if(!newClass.title){
      formIsValid = false;
      errors["title"] = "Title is required";
    }

    if(!newClass.order){
      formIsValid = false;
      errors["order"] = "Order is required";
    }

    if(!prices.uk){
      formIsValid = false;
      errors["uk"] = "Price UK is required";
    }

    if(!prices.hu){
      formIsValid = false;
      errors["hu"] = "Price HU is required";
    }

    setErrors(errors)
    return formIsValid;
  }

  const orderOptions = () => {
    let out = []
    for (let i = 0; i < 100; i++) {
      out.push(<option key={i} value={i+1}>{i+1}</option>)
    }
    return out
  }

  return (<Modal
    show={props.show}
    onHide={props.onHide}
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
  >
    <Modal.Header closeButton>
      Add new Class
    </Modal.Header>
    <Modal.Body>
      <FormGroup>
        <FormLabel>Title</FormLabel>
        <input
          type="text"
          className="form-control"
          placeholder="Title"
          value= {newClass?.title || ''}
          onChange={(e) =>  changeClass(e,'title')}
        />
        <span className="help-block">{errors.title}</span>
      </FormGroup>
      <FormGroup>
        <FormLabel>Ref</FormLabel>
        <input
          type="text"
          className="form-control"
          placeholder="Ref"
          value= {newClass?.ref || ''}
          onChange={(e) =>  changeClass(e,'ref')}
        />
        <span className="help-block">{errors.ref}</span>
      </FormGroup>
      <FormGroup>
        <FormLabel>Order</FormLabel>
        <select
          className= "form-control"
          name= "order"
          value={newClass?.order || ''}
          onChange={(e) =>  changeClass(e,'order')}
        >
          <option value="">Select Order</option>
          {orderOptions()}
        </select>
        <span className="help-block">{errors.order}</span>
      </FormGroup>
      <FormGroup>
        <FormLabel>Price UK</FormLabel>
        <input
          type="number"
          className="form-control"
          placeholder="0.00"
          value= {prices?.uk/100 || ''}
          onChange={(e) =>  changePrice(e,'uk')}
        />
        <span className="help-block">{errors.uk}</span>
      </FormGroup>
      <FormGroup>
        <FormLabel>Price HU</FormLabel>
        <input
          type="number"
          className="form-control"
          placeholder="0.00"
          value= {prices?.hu/100 || ''}
          onChange={(e) =>  changePrice(e,'hu')}
        />
        <span className="help-block">{errors.hu}</span>
      </FormGroup>
    </Modal.Body>
    <Modal.Footer>
      <Button
        className="btn-fill pull-right libi-admin-btn"
        bsStyle="info"
        type="button"
        onClick={addClass}
      >
        {'Create'}
      </Button>
    </Modal.Footer>
  </Modal>)
}

export default AddClassPopup;
